import * as React from 'react';
import { LoadingStateEnum } from '../interfaces/state';

interface LoadingAnalyseProps {
    summary: LoadingStateEnum;
}

export class LoadingAnalyse extends React.Component<LoadingAnalyseProps, {}> {
    constructor(props: LoadingAnalyseProps) {
        super(props);
    }

    render() {
        return (
            <div className="alert alert-info">
                <i className="fas fa-spin fa-circle-notch text-info"></i>&nbsp;
                Loading {this.props.summary.toString()}
            </div>
        );
    }
}
